import { env } from './env';

const AppEnv = () => {
	env.baseUrl =
		(window as any).env?.SSO_APP_BASE_URL || process.env.SSO_APP_BASE_URL;
	env.baseRoute = (window as any).env?.PUBLIC_PATH || process.env.PUBLIC_PATH;
	env.baseStaticUrl =
		(window as any).env?.STATIC_BASE_URL || process.env.STATIC_BASE_URL;
	env.envName = (window as any).env?.ENV;

	return null;
};

export default AppEnv;
